import React, { FunctionComponent, RefObject, useCallback, useEffect } from 'react';

import { Popover2 } from '@yandex-360/orb-components/dist/components/Popover2/Popover2';
import cn from 'classnames';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../../../init-store';
import Button from '../../../../../../shared/components/button';
import SvgImage from '../../../../../../shared/components/svg-image';
import { getIsShownLimitMessage, recordLimitMessageShown } from '../../../../../../shared/features/settings';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { getBroadcastStatus, getBroadcastUri, getParticipants } from '../../../../selectors';
import { shareBroadcastAction } from '../../../broadcast/slice';
import css from './index.css';

const closeIcon = <SvgImage imageName="close" className={css.CloseIcon} />;

const mapState = (state: RootState) => ({
    participants: getParticipants(state),
    uri: state.call.conference.config?.uri,
    broadcastStatus: getBroadcastStatus(state),
    broadcastUri: getBroadcastUri(state),
    isShownLimitMessage: getIsShownLimitMessage(state),
});

const connector = connect(mapState, {
    shareBroadcast: shareBroadcastAction,
    recordLimitMessageShown: recordLimitMessageShown,
});

type Props = ConnectedProps<typeof connector> & {
    visible: boolean;
    anchor: RefObject<HTMLElement>;
    onClose: () => void;
};

const RecordLimitationPopup: FunctionComponent<Props> = ({
    visible,
    anchor,
    onClose,
    isShownLimitMessage,
    recordLimitMessageShown,
}) => {
    const clickInstallApp = useCallback(() => {
        countMetrika('meeting_screen', 'local_record', 'desktop_app_download');
        onClose();
    }, [onClose]);
    const clickOnClose = useCallback(() => {
        countMetrika('meeting_screen', 'local_record', 'tooltip_close');
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (!isShownLimitMessage) {
            countMetrika('meeting_screen', 'local_record', 'tooltip_shown');
            recordLimitMessageShown(true);
        }
    }, [isShownLimitMessage, recordLimitMessageShown]);
    return (
        <Popover2
            triggerRef={anchor}
            placement="top"
            isOpen={visible}
            className={cn(css.Popup, 'js-record-limitation-popup')}
            preventInteractOutside={false}
            autoFocus={false}
        >
            <Button view="neutral-transparent" onClick={clickOnClose} className={css.Close} icon={closeIcon} />
            <span className={css.Description}>{i18n('toolbar', 'show-limitation-popup-description')}</span>
            <Button
                view="brand"
                size="sm"
                onClick={clickInstallApp}
                elementType="a"
                href="/download-desktop"
                target="_blank"
            >
                {i18n('toolbar', 'show-limitation-popup-download')}
            </Button>
        </Popover2>
    );
};

export default connector(RecordLimitationPopup);
